// extracted by mini-css-extract-plugin
export var description = "postMerchantBigCard-module--description--d75fc";